import {
  getDomainAttribute,
  getSecureAttribute,
} from "./cookieAttributes.helper";

interface SetCookieOptions {
  name: string;
  value: string;
  expirationMs: number;
}

interface SerializedCookie {
  cookieString: string;
  encodedValue: string;
  expirationDate: string;
  domainAttribute: string;
  secureAttribute: string;
}

export const serializeCookie = (
  options: SetCookieOptions,
): SerializedCookie => {
  const { name, value, expirationMs } = options;

  const encodedValue = encodeURIComponent(value);
  const expirationDate = new Date(Date.now() + expirationMs).toUTCString();
  const secureAttribute = getSecureAttribute();
  const domainAttribute = getDomainAttribute();
  const cookieString = `${name}=${encodedValue}; Domain=${domainAttribute}; Path=/; Expires=${expirationDate}; SameSite=Strict${secureAttribute}`;

  return {
    cookieString,
    encodedValue,
    expirationDate,
    domainAttribute,
    secureAttribute,
  };
};

export const setCookie = (options: SetCookieOptions): boolean => {
  if (typeof document === "undefined") return false;

  const { name } = options;
  const { cookieString, encodedValue } = serializeCookie(options);

  document.cookie = cookieString;

  return document.cookie
    .split("; ")
    .some((c) => c === `${name}=${encodedValue}`);
};
